import EmployeeImage from '@/assets/images/solution-employee.png'
import AdminImage from '@/assets/images/solution-admin.png'
import OrganisationImage from '@/assets/images/solution-organisation.png'
import ServerImage from '@/assets/images/solution-server.png'

const solutionData = ($t) => {
  return [
    {
      image: EmployeeImage,
      title: $t.TXT_Solution_item1_title,
      item: [
        $t.TXT_Solution_item1_context1,
        $t.TXT_Solution_item1_context2,
        $t.TXT_Solution_item1_context3,
        $t.TXT_Solution_item1_context4,
        $t.TXT_Solution_item1_context5,
        $t.TXT_Solution_item1_context6,
      ],
      hasDot: true,
    },
    {
      image: AdminImage,
      title: $t.TXT_Solution_item2_title,
      item: [
        $t.TXT_Solution_item2_context1,
        $t.TXT_Solution_item2_context2,
        $t.TXT_Solution_item2_context3,
        $t.TXT_Solution_item2_context4,
      ],
      hasDot: true,
    },
    {
      image: OrganisationImage,
      title: $t.TXT_Solution_item3_title,
      item: [$t.TXT_Solution_item3_context1],
      hasDot: false,
    },
    {
      image: ServerImage,
      title: $t.TXT_Solution_item4_title,
      item: [$t.TXT_Solution_item4_context1],
      hasDot: false,
    },
  ]
}

export default solutionData
